import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84e470c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-header border-0 pt-5 pb-3",
  style: {"background":"linear-gradient(135deg, #9aedff 0%, #e1faff 100%)","border-radius":"0.75rem 0.75rem 0 0"}
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label fw-bold fs-6 text-black" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_11 = { class: "card-body pt-6 pb-6" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-header" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px me-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label rounded-circle bg-light-primary" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/icons/dash/user1.png",
      alt: "deals Icon",
      width: "25",
      height: "25"
    })
  ])
], -1))
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_20 = { class: "text-muted fs-6 fw-semibold mb-2" }
const _hoisted_21 = { class: "fs-1 fw-boldest text-dark" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate('brokersAccounts')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.selectedPeriod === 'custom')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.selectedPeriod), 1),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('yesterday')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-7-days' }]),
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('last7Days')), 3)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-30-days' }]),
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('last30Days')), 3)
              ]),
              _hoisted_10,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'custom' }]),
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
                }, _toDisplayString(_ctx.translate('customRange')), 3)
              ])
            ])
          ]),
          _createVNode(_component_CustomDatePicker, {
            show: _ctx.showDatePicker,
            dateFrom: _ctx.customDateFrom,
            "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
            dateTo: _ctx.customDateTo,
            "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
            onApply: _ctx.applyCustomDates,
            onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
          }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.translate('totalBrokersAccounts')), 1),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(' ' + _ctx.totalBrokersAccounts), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.totalBrokersAccountsChangePercentage != 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fs-6 fw-bold d-flex align-items-center",
                        style: _normalizeStyle({ color: _ctx.textColor, minHeight: '20px' })
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.totalBrokersAccountsChangePercentage ?? 0) + "% ", 1),
                        _createElementVNode("img", {
                          class: "w-20px h-20px",
                          src: _ctx.arrowSrc
                        }, null, 8, _hoisted_23)
                      ], 4))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}